module.exports = __webpack_public_path__ + "img/www.8a14ce34.svg";